<template>
  <div class="listing-card-list-view">
    <div class="list-view-block">
      <div class="listing-card-list-value">{{ listing.id }}</div>
      <div class="listing-card-list-value">{{ listing.space_name }}</div>
      <div class="listing-card-list-value">{{ listing.address_label ? listing.address_label : '' }}</div>
      <div class="listing-card-list-value">{{ updated_at_formatted }}</div>
      <div class="listing-list-edit">
        <svg xmlns="http://www.w3.org/2000/svg" @click="editListing">
          <image xlink:href="/images/icons/edit-v3.svg" />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
  import dayjs from 'dayjs'

  export default {
    props: {
      listing: {
        type: Object,
        required: true
      }
    },
    methods: {
      editListing() {
        this.$store.dispatch('modals/showAddListing', {
          edit: this.listing.id
        })
      }
    },
    computed: {
      updated_at_formatted () {
        return this.listing.updated_at ? dayjs(this.listing.updated_at).format('DD/MM/YYYY h:mA') : '';
      }
    }
  }
</script>
